import React from 'react';
import PropTypes from 'prop-types';
import { localeCodes } from '@pcid/locale-utils';
import { Apostrophe, Quote } from '@pcid/string-utils';
import hideQueryParams from '@pcid/utils/hide-query-params';
import Layout, { Heading } from '@pcid/components/layout';
import { withLocale } from '@pcid/components/locale-provider';

class TermsPage extends React.Component {
	static propTypes = {
		locale: PropTypes.string,
	}

	componentDidMount() {
		hideQueryParams('locale');
	}

	render() {
		const { locale } = this.props;
		return (
			<Layout title="page.terms.title" className="terms-page" relyingParty={null}>
				<Heading id="page.terms.heading" />
				{ locale === localeCodes.FR
					/* eslint-disable max-len */
					? (
						<ol>
							<li>
								<h2>Modalités d’utilisation du présent site</h2>
								<p>
									Les Compagnies Loblaw Limitée et/ou une filiale de Les Compagnies Loblaw Limitée
									(individuellement et collectivement désignées aux présentes par « Loblaw ») ont le
									plaisir de mettre le présent site à votre disposition pour votre usage personnel.
									Toutefois, en utilisant le présent site, vous acceptez les modalités d’utilisation
									décrites ci-dessous. Advenant que des modalités d’utilisation de quelque site que
									ce soit d’une filiale de Les Compagnies Loblaw Limitée soient en conflit avec les
									présentes modalités d’utilisation ou soient incohérentes par rapport à celles-ci,
									ce sont les modalités d’utilisation du site en question qui prévaudront et qui
									s’appliqueront dans la seule mesure où le conflit ou l’incohérence se rapportent à
									l’utilisation de ce dernier.
								</p>
							</li>
							<li>
								<h2>Utilisation du site et de son contenu</h2>
								<p>
									Sauf indication contraire, expressément énoncée aux présentes, ce site est mis à
									votre disposition pour votre utilisation personnelle à des fins non commerciales
									et il vous est interdit de copier du matériel provenant de ce site à des fins
									commerciales. Vous pouvez copier du matériel provenant du présent site en quantité
									limitée pour votre utilisation personnelle à des fins non commerciales, à
									condition que notre avis de droits d’auteur soit apposé sur le matériel copié.
									Loblaw se réserve le droit de limiter en tout temps votre utilisation du site,
									notamment de vous retirer l’autorisation de faire des copies du matériel provenant
									du présent site.
								</p>
								<p>
									Il vous est interdit d’utiliser ce site pour publier ou transmettre tout matériel
									illégal, menaçant, diffamatoire, obscène, scandaleux, outrageant, pornographique
									ou blasphématoire ou tout matériel susceptible de constituer des agissements
									illicites ou de les cautionner. Loblaw peut, de temps à autre, surveiller ou
									examiner le contenu transmis par l’intermédiaire du présent site ou affiché sur
									celui-ci et se réserve le droit de supprimer tout matériel qu’elle jugera
									inapproprié. Loblaw n’y est aucunement obligé et, par conséquent, décline toute
									responsabilité à l’égard du matériel transmis par l’intermédiaire du site ou
									affiché sur celui-ci et à l’égard des dommages pouvant en résulter.
								</p>
							</li>
							<li>
								<h2>Marques de commerce et droit à la propriété intellectuelle</h2>
								<p>
									Vous utilisez le présent site et le matériel provenant de celui-ci à vos propres
									risques.
								</p>
								<p>
									Loblaw s’efforce que l’information concernant le matériel présenté sur le présent
									site soit exacte et à jour. Néanmoins, Loblaw ne fait aucune représentation et ne
									donne aucune garantie concernant l’exactitude ou la présentation de l’information
									en temps opportun du matériel offert sur ce site. Loblaw décline toute
									responsabilité pour toute erreur ou omission sur ce site et les dommages pouvant
									en résulter.
								</p>
								<p>
									Le présent site peut contenir des documents (ou faire référence à des documents)
									contenant des énoncés de nature prospective qui prennent en compte les attentes de
									la direction à l’égard de la croissance, des résultats d’exploitation et de la
									performance à venir, ainsi que des perspectives et occasions d’affaires relatives
									à Loblaw. Dans la mesure du possible, des mots tels que « anticipe », « croit », «
									s’attend à », « a l’intention de » et des expressions similaires ont été utilisées
									pour identifier les énoncés de nature prospective. Ces énoncés reflètent les
									opinions de la direction et sont basés sur les renseignements qui étaient à sa
									disposition au moment où les documents ont été préparés. Les énoncés de nature
									prospective s’accompagnent de risques importants, d’incertitudes et d’hypothèses.
									De nombreux facteurs peuvent intervenir et faire en sorte que les résultats réels,
									la performance ou les réalisations diffèrent substantiellement des résultats (ou
									des résultats implicites) mentionnés dans les énoncés de nature prospective. Ces
									facteurs devraient être considérés avec attention et les investisseurs potentiels
									ne devraient pas se fier de façon indue aux énoncés de nature prospective. Bien
									que les énoncés de nature prospective contenus sur le présent site ou dans les
									documents auxquels ce site fait référence soient basés sur ce que la direction
									croit être des hypothèses raisonnables, Loblaw ne peut pas garantir aux acheteurs
									potentiels que les résultats réels seront conformes aux énoncés de nature
									prospective. Ces énoncés de nature prospective sont élaborés à la date à laquelle
									les documents ont été préparés et Loblaw n’est aucunement tenu de les mettre à
									jour ou de les réviser pour qu’ils tiennent compte des nouveaux événements et des
									nouvelles circonstances.
								</p>
								<p>
									Ni Loblaw, ni aucun de ses mandataires, ni toute autre partie ayant participé à la
									création, à la production ou à la livraison de ce site ne peut être tenu
									responsable de quelque dommage que ce soit pouvant survenir à la suite de votre
									accès à ce site ou de votre utilisation de ce site ou de tout matériel provenant
									de celui-ci. Sans restreindre la portée de ce qui précède, le présent site et tout
									le matériel y figurant sont fournis « EN L’ÉTAT » SANS GARANTIE D’AUCUNE SORTE
									EXPRESSE OU TACITE, Y COMPRIS, MAIS NON EXCLUSIVEMENT, TOUTE GARANTIE IMPLICITE DE
									QUALITÉ MARCHANDE, D’ADAPTATION À UN USAGE PARTICULIER OU D’ABSENCE DE CONTREFAÇON.
								</p>
								<p>
									Loblaw décline toute responsabilité pour tout dommage que vous, votre ordinateur,
									ou d’autres biens vous appartenant pourriez subir en accédant au présent site, en
									l’utilisant ou téléchargeant tout matériel mis à disposition sur celui-ci.
								</p>
							</li>
							<li>
								<h2>Avis de non-responsabilité</h2>
								<p>
									Vous utilisez le présent site et le matériel provenant de celui-ci à vos propres
									risques.
								</p>
								<p>
									Loblaw s’efforce que l’information concernant le matériel présenté sur le présent
									site soit exacte et à jour. Néanmoins, Loblaw ne fait aucune représentation et ne
									donne aucune garantie concernant l’exactitude ou la présentation de l’information
									en temps opportun du matériel offert sur ce site. Loblaw décline toute
									responsabilité pour toute erreur ou omission sur ce site et les dommages pouvant
									en résulter.
								</p>
								<p>
									Le présent site peut contenir des documents (ou faire référence à des documents)
									contenant des énoncés de nature prospective qui prennent en compte les attentes de
									la direction à l’égard de la croissance, des résultats d’exploitation et de la
									performance à venir, ainsi que des perspectives et occasions d’affaires relatives
									à Loblaw. Dans la mesure du possible, des mots tels que « anticipe », « croit », «
									s’attend à », « a l’intention de » et des expressions similaires ont été utilisées
									pour identifier les énoncés de nature prospective. Ces énoncés reflètent les
									opinions de la direction et sont basés sur les renseignements qui étaient à sa
									disposition au moment où les documents ont été préparés. Les énoncés de nature
									prospective s’accompagnent de risques importants, d’incertitudes et d’hypothèses.
									De nombreux facteurs peuvent intervenir et faire en sorte que les résultats réels,
									la performance ou les réalisations diffèrent substantiellement des résultats (ou
									des résultats implicites) mentionnés dans les énoncés de nature prospective. Ces
									facteurs devraient être considérés avec attention et les investisseurs potentiels
									ne devraient pas se fier de façon indue aux énoncés de nature prospective. Bien
									que les énoncés de nature prospective contenus sur le présent site ou dans les
									documents auxquels ce site fait référence soient basés sur ce que la direction
									croit être des hypothèses raisonnables, Loblaw ne peut pas garantir aux acheteurs
									potentiels que les résultats réels seront conformes aux énoncés de nature
									prospective. Ces énoncés de nature prospective sont élaborés à la date à laquelle
									les documents ont été préparés et Loblaw n’est aucunement tenu de les mettre à
									jour ou de les réviser pour qu’ils tiennent compte des nouveaux événements et des
									nouvelles circonstances.
								</p>
								<p>
									Ni Loblaw, ni aucun de ses mandataires, ni toute autre partie ayant participé à la
									création, à la production ou à la livraison de ce site ne peut être tenu
									responsable de quelque dommage que ce soit pouvant survenir à la suite de votre
									accès à ce site ou de votre utilisation de ce site ou de tout matériel provenant
									de celui-ci. Sans restreindre la portée de ce qui précède, le présent site et tout
									le matériel y figurant sont fournis « EN L’ÉTAT » SANS GARANTIE D’AUCUNE SORTE
									EXPRESSE OU TACITE, Y COMPRIS, MAIS NON EXCLUSIVEMENT, TOUTE GARANTIE IMPLICITE DE
									QUALITÉ MARCHANDE, D’ADAPTATION À UN USAGE PARTICULIER OU D’ABSENCE DE CONTREFAÇON.
								</p>
								<p>
									Loblaw décline toute responsabilité pour tout dommage que vous, votre ordinateur,
									ou d’autres biens vous appartenant pourriez subir en accédant au présent site, en
									l’utilisant ou téléchargeant tout matériel mis à disposition sur celui-ci.
								</p>
							</li>
							<li>
								<h2>Liens</h2>
								<p>
									Loblaw n’a examiné, en tout ou en partie, aucun des sites Web pouvant être liés au
									présent site et décline toute responsabilité à l’égard de tout site lié au présent
									site. La consultation d’un site externe est donc à vos risques. En établissant le
									lien vers un site ou en permettant un lien vers le présent site, Loblaw ne
									cautionne pas l’exploitant du site ou n’assume pas la responsabilité du contenu du
									site en lien.
								</p>
							</li>
							<li>
								<h2>Communication d’idées et utilisation de l’information</h2>
								<p>
									Loblaw n’accepte aucune idée non sollicitée pour de nouveaux produits et
									emballages, pour du marketing, de la publicité, de la recherche, pour des
									activités commerciales, etc. Si vous ne respectez pas la présente politique, et
									que vous soumettez une idée à Loblaw, vous acceptez que l’idée devienne et demeure
									la propriété exclusive de Loblaw sans aucune obligation de la part de Loblaw et
									sans qu’aucune rémunération vous soit accordée par Loblaw.
								</p>
								<p>
									Si, en répondant à Loblaw, vous communiquez des renseignements, y compris, mais
									sans s’y limiter des rétroactions, des données, des commentaires, des suggestions
									et des renseignements du même ordre, ces renseignements ne sont pas réputés
									confidentiels. Tous les renseignements communiqués sont réputés être la propriété
									de Loblaw, et, en soumettant ces renseignements, vous cédez à Loblaw tous les
									droits, titres, et intérêts de tels renseignements dans le monde entier. Loblaw ne
									pourra être tenue responsable de toute utilisation ou divulgation de ces
									renseignements. Loblaw ne pourra être tenue responsable de toute utilisation ou
									divulgation de ces renseignements. Loblaw n’a aucune obligation de garder ces
									renseignements confidentiels et sera libre de reproduire, d’utiliser, de divulguer
									et de distribuer les renseignements à d’autres sans aucune restriction Loblaw peut
									aussi utiliser les idées, les concepts, le savoir-faire ou les techniques
									présentés dans ces renseignements à quelque fin que ce soit, notamment pour
									l’élaboration, la fabrication ou la commercialisation d’un produit d’après ces
									renseignements ou en y intégrant les renseignements.
								</p>
								<p>
									En vous invitant à lui faire part de vos commentaires et de vos suggestions sur ce
									site et sur les produits, Loblaw ne cherche pas à solliciter auprès de vous des
									idées, des suggestions, du matériel ou d’autres renseignements confidentiels ou
									exclusifs concernant la mise au point, la conception, le design, la modification,
									la fabrication ou le marketing de ses produits ou de tout nouveau produit. En
									communiquant des renseignements, vous garantissez à Loblaw le droit de les publier,
									de les utiliser dans le cadre de ses activités, et d’intégrer les concepts qui
									ont été communiqués dans les produits de Loblaw sans aucune obligation de Loblaw à
									votre égard et sans qu’aucune rémunération ne vous soit accordée.
								</p>
							</li>
							<li>
								<h2>Droit applicable</h2>
								<p>
									Vous convenez que toute utilisation de ce site est régie par les lois de la
									Province de l’Ontario, Canada, sans donner effet à quelque principe relatif au
									conflit de lois, y compris en ce qui concerne tout litige pouvant survenir à la
									suite de votre utilisation du présent site ou du matériel qui en provient. La
									Convention des Nations Unies sur les contrats de vente internationale de
									marchandises ne s’applique pas. Les tribunaux de la Province de l’Ontario ont une
									compétence exclusive sur toutes les réclamations.
								</p>
							</li>
							<li>
								<h2>Achats en ligne</h2>
								<p>
									Toutes les commandes passées par l’intermédiaire d’un site Web de Loblaw seront
									assujetties aux modalités de l’achat en question énoncées sur le site Web ainsi
									qu’aux modalités supplémentaires suivantes : le prix et les autres modalités de
									l’achat du produit en question seront ceux qui sont énoncés sur le site Web
									concerné, et ces renseignements peuvent être modifiés en tout temps sans préavis.
									Les prix peuvent être différents de ceux établis pour des achats effectués par
									l’intermédiaire d’autres canaux. Vous avez l’obligation juridique de payer toute
									commande identifiée comme ayant été passée par vous. Vous devez avoir atteint
									l’âge légal de la majorité de votre pays pour pouvoir passer des commandes en
									ligne.
								</p>
							</li>
							<li>
								<h2>Disposition dissociée et intégralité de l’entente</h2>
								<p>
									Si l’une des dispositions de la présente entente est déclarée non exécutoire,
									cette disposition est considérée comme dissociée de la présente entente et n’a
									aucun effet sur la validité ou le caractère exécutoire des autres dispositions.
								</p>
								<p>
									La présente entente constitue l’intégralité de l’entente entre les parties
									relativement à l’objet des présentes.
								</p>
								<p>
									Loblaw se réserve le droit de modifier les présentes modalités d’utilisation en
									tout temps et sans préavis.
								</p>
							</li>
							<li>
								<h2>Accès à d’autres sites Web et programmes de Loblaw</h2>
								<p>
									Votre identifiant PCMC est un identifiant universel qui vous permet d’accéder à
									vos comptes sur une variété de plateformes en ligne de Loblaw, comme les sites Web
									et les applications mobiles, y compris ceux en lien avec les bannières Loblaw et
									les programmes pour consommateurs tels que PC Optimum. L’utilisation de ces
									programmes pour les consommateurs et de certaines capacités des applications
									mobiles ainsi que des sites Web de bannières de Loblaw, comme PC Express,
									accessibles par l’entremise de votre identifiant PCMC peut être soumise à des
									modalités supplémentaires.
								</p>
								<p>
									<sup>MD/MC</sup> PC, PC Express, le Choix du Président sont des marques de
									commerce de Loblaws inc.
								</p>
								<p>PC Optimum est utilisée sous licence.</p>
							</li>
						</ol>
					)
					: (
						<ol>
							<li>
								<h2>Terms and conditions for use of this site</h2>
								<p>
									Loblaw Companies Limited and/or a Loblaw Companies Limited subsidiary
									(collectively and individually <Quote>Loblaw</Quote>) is pleased to provide this
									web site for your personal use. However, by using this site, you agree to the
									terms and conditions provided below. In the event that any Loblaw Companies
									Limited subsidiary site contains terms and conditions for the use of that site
									which conflict with or are inconsistent with these terms and conditions, those
									terms and conditions will prevail and govern to the extent of the conflict or
									inconsistency in connection with the use of that site.
								</p>
							</li>
							<li>
								<h2>Use of Site and Site Material</h2>
								<p>
									Except as expressly stated therein, this site is provided for your personal
									noncommercial use and you may not copy material from this site for commercial use.
									You may copy material in limited quantities from this site for your personal
									noncommercial use provided that our copyrights notice is affixed to the copied
									material. Loblaw reserves the right to restrict your use of this site at any time,
									which may include terminating your permission to make personal copies of material
									from this site.
								</p>
								<p>
									You are prohibited from using this site to post or transmit any unlawful,
									threatening, libelous, defamatory, obscene, scandalous, inflammatory, pornographic
									or profane material or any material that could constitute or encourage unlawful
									conduct. Loblaw may from time to time monitor or review material transmitted or
									posted using this site and reserves the right to delete any material the company
									deems inappropriate. Loblaw is under no obligation to do so and assumes no
									responsibility or liability arising from any material transmitted or posted using
									this site.
								</p>
							</li>
							<li>
								<h2>Trademarks and Ownership of Intellectual Property</h2>
								<p>
									Loblaw owns the copyright to all material on and from this site. Notwithstanding
									any other term or condition in this Agreement, Loblaw retains ownership to the
									copyright in this site and all material on and from this site.
								</p>
								<p>
									This web site contains many of the valuable trademarks, names, package designs,
									copyrights and other proprietary material owned and used by Loblaws Inc. and/or
									its affiliated companies including but not limited to President<Apostrophe />s
									Choice® and PC® (the <Quote>Trademarks</Quote>).
								</p>
								<p>
									The Trademarks on this web site are protected from copying or reproduction under
									national and international trademark and copyright laws and nothing contained
									herein shall be construed as conferring by implication or otherwise any license or
									right under any patent, trademark, copyright or other proprietary right. Therefore
									the use of the Trademarks is strictly prohibited. All rights reserved.
								</p>
							</li>
							<li>
								<h2>Disclaimer</h2>
								<p>Your use of this site and material from this site is at your own risk.</p>
								<p>
									Loblaw strives to provide accurate and up-to-date material on this site. However,
									Loblaw makes no warranties or representations as to the accuracy or timeliness of
									the material provided on this site. Loblaw assumes no liability or responsibility
									for any errors or omissions on this site.
								</p>
								<p>
									This site may contain, or refer to, documents containing forward-looking
									statements which reflect management<Apostrophe />s expectations regarding
									Loblaw<Apostrophe />s future growth, results of operations, performance and
									business prospects and opportunities. Wherever possible, words such as
									<Quote>anticipate</Quote>, <Quote>believe</Quote>, <Quote>expects</Quote>,
									<Quote>intend</Quote> and similar expressions have been used to identify these
									forward-looking statements. These statements reflect management<Apostrophe />s
									beliefs, and are based on information available to management, at the time the
									documents were prepared. Forward-looking statements involve significant risk,
									uncertainties and assumptions. A number of factors could cause actual results,
									performance or achievements to differ materially from the results discussed or
									implied in the forward-looking statements. These factors should be considered
									carefully and prospective investors should not place undue reliance on the
									forward-looking statements. Although the forward-looking statements contained in
									this site or in documents referred to in this site are based upon what management
									believes to be reasonable assumptions, Loblaw cannot assure prospective purchasers
									that the actual results will be consistent with these forward-looking statements.
									These forward-looking statements are made as of the date the documents were
									prepared, and Loblaw assumes no obligation to update or revise them to reflect new
									events or circumstances.
								</p>
								<p>
									Neither Loblaw, any of its agents, nor any other party involved in creating,
									producing, or delivering this site is liable for any damages whatsoever arising
									out of your access to, or use of, this site or any material from this site.
									Without limiting the foregoing, this site and the material provided on this site
									are provided <Quote>AS IS</Quote> WITHOUT WARRANTY OF ANY KIND EITHER EXPRESSED OR
									IMPLIED, INCLUDING BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY,
									FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT.
								</p>
								<p>
									Loblaw assumes no liability or responsibility for any damage to you, your computer
									or your other property, due to your access to, use of, or downloading of this
									site or any materials provided on this site.
								</p>
							</li>
							<li>
								<h2>Link</h2>
								<p>
									Loblaw has not reviewed any or all of the sites that may be linked to this site
									and is not responsible for any sites linked to this site. Your linking to any
									sites from this site is at your own risk. By linking to a site or permitting a
									link to this site, Loblaw does not endorse the site operator or the content of the
									linked site.
								</p>
							</li>
							<li>
								<h2>Idea Submission/Use of Information</h2>
								<p>
									Loblaw does not accept unsolicited ideas for new products, packaging, marketing,
									advertising, research, business operations and the like. Should you ignore this
									policy and submit an idea to Loblaw, you agree that the idea becomes and remains
									the sole and exclusive property of Loblaw without further liability or
									compensation to you.
								</p>
								<p>
									If you respond to Loblaw with any information, including but not limited to
									feedback, data, questions, comments, suggestions, or the like, such information
									shall not be deemed confidential. All such submissions shall be deemed the
									property of Loblaw, and your submission of information shall constitute an
									assignment to Loblaw of all worldwide rights, titles, and interests in such
									information. Loblaw will not be liable for any use or disclosure of such
									information. Loblaw will not have any obligation to keep such information
									confidential and will be free to reproduce, use, disclose and distribute the
									information to others without limitation. Loblaw will be free to use any ideas,
									concept, know-how or techniques contained in such information for any purpose
									whatsoever, including but not limited to developing, manufacturing and marketing
									products which incorporate or otherwise rely upon such information.
								</p>
								<p>
									Loblaw welcomes your comments and suggestions on this site and products, but
									Loblaw does not seek to solicit any confidential or proprietary ideas, suggestions,
									materials or other information relating to developing, designing, redesigning,
									modifying, manufacturing or marketing its products or any new products. By
									submitting information, you warrant that Loblaw may publish such information, use
									it as part of its operations, and incorporate its concepts in Loblaw products
									without liability or compensation to you.
								</p>
							</li>
							<li>
								<h2>Applicable Law</h2>
								<p>
									You agree that the laws of the Province of Ontario, Canada govern any use of this
									site, without regard to rules relating to conflict of laws, including with regard
									to any dispute arising out of your use of this site or material from this site.
									The United Nations Convention on Contracts for the International Sale of Goods
									shall not apply. The courts of the Province of Ontario shall have exclusive
									jurisdiction over all claims.
								</p>
							</li>
							<li>
								<h2>Online Purchases</h2>
								<p>
									All orders made through a Loblaw web site will be subject to the terms and
									conditions outlined in the web site relating to the purchase in question and the
									following additional terms and conditions. Pricing and other terms and conditions
									relating to the purchase of the product in question will be as stated in
									applicable website, and this information may be changed at any time without
									notice. Prices may differ from those for purchases made through other channels.
									You have a legal obligation to pay for any orders indicated to be made by you. You
									must be of the age of majority in your jurisdiction to make online purchases.
								</p>
							</li>
							<li>
								<h2>Severed Provisions and Entire Agreement</h2>
								<p>
									If any provision of this agreement is unenforceable, that provision shall be
									deemed severed from this agreement and shall not affect the validity and
									enforceability of the remaining provisions.
								</p>
								<p>This is the entire agreement between the parties relating to the subject matter.</p>
								<p>Loblaw may modify these terms and conditions at any time and without notice.</p>
							</li>
							<li>
								<h2>Access to other Loblaw web sites and programs</h2>
								<p>
									Your PC™id is a universal login that allows you to access your accounts across a
									variety of Loblaw online platforms, such as websites and mobile apps, including
									those in respect of Loblaw banners and consumer programs, such as PC Optimum. Your
									use of such consumer programs and certain capabilities within Loblaw banner
									websites and mobile apps, such as PC Express accessed through your PC™id may be
									subject to additional terms and conditions.
								</p>
								<p>
									®/TM PC, PC Express, President<Apostrophe />s Choice – Trademarks of Loblaws Inc.
								</p>
								<p>PC Optimum used under license.</p>
							</li>
						</ol>
					)}
			</Layout>
		);
	}
}

export default withLocale(TermsPage);
